<h2 mat-dialog-title>Enter Edit Code</h2>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div mat-form-field class="full-width">
    <div mat-label>Edit Code</div>
    <input matInput type="password" formControlName="code" autocomplete="off">
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
  </div>

  <mat-error *ngIf="error">{{ error }}</mat-error>
</form>
